import React, { useState, useEffect, useMemo } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/Dheeraj_Jain_Resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const DESKTOP_BREAKPOINT = 786;
const DESKTOP_SCALE = 1.7;
const MOBILE_SCALE = 0.6;
const DEFAULT_WIDTH = 1200;

const downloadButtonStyle = { maxWidth: "250px" };
const downloadButtonRowStyle = {
  justifyContent: "center",
  position: "relative",
};

const DownloadButton = React.memo(() => (
  <Button
    variant="primary"
    href={pdf}
    target="_blank"
    style={downloadButtonStyle}
  >
    <AiOutlineDownload />
    &nbsp;Download CV
  </Button>
));

const DownloadButtonRow = React.memo(() => (
  <Row style={downloadButtonRowStyle}>
    <DownloadButton />
  </Row>
));

function ResumeNew() {
  const [width, setWidth] = useState(DEFAULT_WIDTH);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  const pageScale = useMemo(
    () => (width > DESKTOP_BREAKPOINT ? DESKTOP_SCALE : MOBILE_SCALE),
    [width],
  );

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <DownloadButtonRow />

        <Row className="resume">
          <Document file={pdf} className="d-flex justify-content-center">
            <Page
              pageNumber={1}
              scale={pageScale}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Document>
        </Row>

        <DownloadButtonRow />
      </Container>
    </div>
  );
}

export default React.memo(ResumeNew);
